import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/yeppy/project_statement.png";
import { StaticImage } from "gatsby-plugin-image";

const Problemyeppy = () => {
  return (
    <div
      className="problem_yeppy"
      style={{ backgroundImage: `url(${BgImg})`, overflow: "hidden" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={4}
            xl={4}
            xxl={4}
            className="offset-xl-8 offset-lg-8 my-md-auto my-lg-0 my-xl-0 my-xxl-0"
          >
            <div className="pro_head_yeppy">
              <h2>Problem Statement</h2>
              <p>
                Mobile users often face the inconvenience of using multiple apps
                for various daily tasks, such as Financial, Booking, Retail, and
                Exclusive. They often navigate and manage multiple apps, leading
                to a fragmented and less user-friendly experience.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} className="offset-xl-8 offset-lg-8 offset-md-0">
            <StaticImage
              src="../../../images/case-studies/yeppy/problem_mob_view.png"
              alt="TekRevol"
              className="img-fluid d-sm-block d-md-none d-lg-none d-xl-none d-xxl-none"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={681}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Problemyeppy;
